import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    selectSharedImages: {
      marginTop: '1.25rem',
      textAlign: 'center',
    },

    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
    uploadActions: {
      color: '#8C8C8C',
      display: 'flex',
      fontSize: '12px',
      fontWeight: '400',
      marginTop: '1rem',
      width: 'fit-content',
    },
    uploadRadiologyReport: {
      marginTop: '1.25rem',
    },
    viewSharedImageButton: {
      color: '#2AAAE2',
      cursor: 'pointer',
      marginLeft: '8px',
    },
    viewSharedImageButtonDisabled: {
      color: '#DDDDDD',
      cursor: 'not-allowed',
      marginLeft: '8px',
    },
  };
});

export default ({ fileStatus, onRemoveSharedImage, loadingSharedImageDetail, onSelectSharedImage, onViewSharedImage }) => {
  const classes = useStyles();

  const handleSelectSharedImage = (e) => {
    if (onSelectSharedImage) onSelectSharedImage(e);
  };

  if (fileStatus.sharedImageSelected) {
    return (
      <>
        <Typography className="field-label text-left my-1">
          Shared Image <span style={{ color: '#B12A2A' }}>*</span>
        </Typography>
        <Grid container className={`${classes.uploadRadiologyReport} ${classes.statsContainer}`}>
          <Grid item xs={12}>
            <Typography className={classes.statsText}> {fileStatus.sharedImage.title || fileStatus.sharedImage?.resource?.patientName} </Typography>
          </Grid>
        </Grid>
        <div className={classes.uploadActions}>
          <span onClick={onRemoveSharedImage} style={{ color: '#B12A2A', cursor: 'pointer' }} aria-hidden="true">
            Remove
          </span>
          <span
            onClick={() => (loadingSharedImageDetail ? undefined : onViewSharedImage(fileStatus.sharedImage))}
            className={loadingSharedImageDetail ? classes.viewSharedImageButtonDisabled : classes.viewSharedImageButton}
            aria-hidden="true">
            View
          </span>
        </div>
      </>
    );
  }
  return (
    <Button onClick={handleSelectSharedImage} variant="outlined" fullWidth component="span" className={classes.selectSharedImages} color="primary">
      Link to images on PACS (for radiology group use)
    </Button>
  );
};
